export default class RapportsActivitesService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getSocietesCom() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getProduitsStocksElements() {
		let url = `${__configuration.apiUrl}/massia/domaines/produitsstockes/elements-hierarchiques`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getAllRapportActivites() {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/gestion/rapports-activites`);
		return res.data;
	}

	async getSecteursByRapportAndGroupeSite(id, idGroupeSite) {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/gestion/rapports-activites/${id}/groupe-site/${idGroupeSite}/secteurs`);
		return res.data;
	}

	async getRegroupementSitesBySociete(idSociete) {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/regroupement-sites/societe/${idSociete}`);
		return res.data;
	}

	async saveRapportsActivites(data) {
		const res = await this.$http.put(`${__configuration.apiUrl}/massia/gestion/rapports-activites`, data);
		return res.data;
	}

	async duplicateRapportActivites(idRapport, data) {
		const res = await this.$http.put(`${__configuration.apiUrl}/massia/gestion/rapports-activites/${idRapport}/duplicate`, data);
		return res.data;
	}

	async saveRapportsOrganistaionsProduits(idRapport, idRegroupementSite, data) {
		const res = await this.$http.put(
			`${__configuration.apiUrl}/massia/gestion/rapports-activites/${idRapport}/organisation-produits/${idRegroupementSite}`,
			data
		);
		return res.data;
	}

	async reinitialiseRapportGroupeSite(idRapport, idRegroupementSite) {
		const res = await this.$http.put(
			`${__configuration.apiUrl}/massia/gestion/rapports-activites/${idRapport}/reinitialise/${idRegroupementSite}`
		);
		return res.data;
	}
}
